import React from 'react';
import classnames from 'classnames';
import placeholders from './Placeholders';
export default class LoadingPlaceholder extends React.Component {
    constructor(props) {
        super(props);
        this.getFiller = () => {
            const { customBlocks, showLoadingAnimation, style, className } = this.props;
            const filterCls = classnames({
                'cfm_loading_animation': showLoadingAnimation,
            }, className);
            return (<div className={filterCls} style={style}>
        {customBlocks}
      </div>);
        };
        this.setNotReady = () => {
            const { delay } = this.props;
            if (delay && delay > 0) {
                this.timeout = window.setTimeout(() => {
                    this.setState({ ready: false });
                }, delay);
            }
            else {
                this.setState({ ready: false });
            }
        };
        this.setReady = () => {
            if (this.timeout) {
                window.clearTimeout(this.timeout);
            }
            if (!this.state.ready) {
                this.setState({ ready: true });
            }
        };
        this.objType = (obj) => {
            return Object.prototype.toString.call(obj).slice(8, -1);
        };
        this.state = {
            ready: this.props.ready,
        };
    }
    componentWillReceiveProps(nextProps) {
        if (!this.props.firstLaunchOnly && this.state.ready && !nextProps.ready) {
            this.setNotReady();
        }
        else if (nextProps.ready) {
            this.setReady();
        }
    }
    render() {
        return this.state.ready ? <React.Fragment>{this.props.children}</React.Fragment> : this.getFiller();
    }
}
LoadingPlaceholder.cfBlock = placeholders.cfBlock;
LoadingPlaceholder.cfText = placeholders.cfText;
LoadingPlaceholder.cfRound = placeholders.cfRound;
LoadingPlaceholder.cfRect = placeholders.cfRect;
LoadingPlaceholder.cfImg = placeholders.cfImg;
LoadingPlaceholder.cfMedia = placeholders.cfMedia;
LoadingPlaceholder.defaultProps = {
    delay: 0,
    showLoadingAnimation: true,
    firstLaunchOnly: false,
};



// WEBPACK FOOTER //
// ./components/loading-placeholder/index.tsx